import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import FrontText from "../FrontText";
import { Trans, useTranslation } from "react-i18next";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import { Link } from "@inertiajs/react";

const ServiceDescription = ({ contentKey, components, children, lng }) => {
    if (!components) {
        components = {
            1: <Link href={resolveLocaleRoute('front.home', null, lng)} title="Magazyny na wynajem"/>,
        }
    }
    return (
        <Container>
            <Row className='justify-between items-center xl:mb-40 lg:mb-30 md:mb-20 mb-15'>
                <Column xl={6} lg={6} md={6}>
                    <FrontText className="[&_p]:mb-5 [&_a]:font-semibold" textSize={'16/20'}>
                        <Trans i18nKey={contentKey} components={components}/>
                    </FrontText>
                </Column>
                
                <Column xl={5} lg={5} md={6}>
                    {children}
                </Column>
            </Row>
        </Container>
    )
}

export default ServiceDescription;